
import NavigationNode from '@/services/NavigationNode';

export default class TreeExpander {

	// magic numbers determined empirically

	/**
	 * Height of a single item
	 */
	static readonly baseItemHeight = 37;

	/**
	 * Extra max-height to make sure there's no clipping
	 * (max height, not height - won't cause whitespace)
	 */
	static readonly overflowHeight = 40;

	static countNodes(parentNode: NavigationNode, runningCount: number): number {
		let count = 0;

		parentNode.nodes.forEach((node: NavigationNode) => {
			count += 1;
			count = TreeExpander.countNodes(node, count);
		});

		return runningCount + count;
	}

	static countVisibleNodes(parentNode: NavigationNode, runningCount: number): number {
		let count = 0;

		if (parentNode.hideChildren) {
			return runningCount;
		}

		parentNode.nodes.forEach((node: NavigationNode) => {
			if (node.hideChildren) {
				return;
			}

			count += 1;
			count = TreeExpander.countNodes(node, count);
		});

		return runningCount + count;
	}

	static getTreeMaxHeight(item: NavigationNode): number {
		return (TreeExpander.countNodes(item, 0) * TreeExpander.baseItemHeight) + TreeExpander.overflowHeight;
	}

	static getTreeHeight(item: NavigationNode): number {
		return (TreeExpander.countVisibleNodes(item, 0) * TreeExpander.baseItemHeight) + TreeExpander.overflowHeight;
	}

}

